import { useContext, useEffect } from "react";
import "../../../../styles/workspace_styles/SystemAdministratorStyles/TenantAdministrators/TenantAdministrators.css";
import NavigationBar from "../../../navigation_components/NavigationBar";
import SystemAdministratorSideBar from "../../../sidebar_components/SystemAdministratorSideBar";
import NewTenantAdministrator from "./NewTenantAdministrator";
import { TenantAdministratorContext } from "./TenantAdministratorProvider";
import { AppContext } from "../../../AppProvider";
import { usersMicroserviceUrl } from "../../../../microservices/users_microservice";
import DeleteTenantAdministrator from "./DeleteTenantAdministrator";
import EditTenantAdministrator from "./EditTenantAdministrator";
const TenantAdministratorsTable = () => {
    const {
        tenantAdministrators,
        setSelectedToEditTenantAdministrator,
        setSelectedToDeleteTenantAdministrator
    } = useContext(TenantAdministratorContext);
    if(!Array.isArray(tenantAdministrators)) return null;
    return(
        <div className="system-administrator-tenant-administrators-table-container">
            <table>
                <thead>
                    <tr id="system-administrator-tenant-administrators-table-header-row">
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email Address</th>
                        <th>Created at</th>
                        <th>Created by</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {tenantAdministrators && [...tenantAdministrators].map((tenantAdministrator) =>(
                        <tr key={tenantAdministrator?.id}>
                            <td>{tenantAdministrator?.firstName}</td>
                            <td>{tenantAdministrator?.lastName}</td>
                            <td>{tenantAdministrator?.emailAddress}</td>
                            <td>{tenantAdministrator?.dateCreated}</td>
                            <td>{tenantAdministrator?.createdBy?.names}</td>
                            <td>
                                <img
                                    title="Edit tenant administrator"
                                    onClick={() => setSelectedToEditTenantAdministrator(tenantAdministrator)}
                                    src={`${process.env.PUBLIC_URL}/images/edit-icon.png`}
                                />
                                <img title="Delete tenant administrator"
                                    onClick={() => setSelectedToDeleteTenantAdministrator(tenantAdministrator)}
                                    src={`${process.env.PUBLIC_URL}/images/delete-icon.png`}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
const TenantAdministrators = () =>{
    const {user,logout} = useContext(AppContext);
    const {
        showCreateNewTenantAdministratorWindow,
        setShowCreateNewTenantAdministratorWindow,
        tenantAdministrators,setTenantAdministrators,
        reloadTenantAdministrators,setReloadTenantAdministrators,
        selectedToDeleteTenantAdministrator
    } = useContext(TenantAdministratorContext);
    const fetchTenantAdministrators = async() =>{
        try{
            const url = `${usersMicroserviceUrl}/system-admins/tenants`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok) setTenantAdministrators(await response.json());
            else if(response.status === 401) logout();
        }
        catch(error){
            console.error('An error occurred when retrieving tenant administrators',error);
        }
    };
    useEffect(() => {
        document.title = 'Blink IOT | Tenant administrators';
        fetchTenantAdministrators();
    },[]);
    useEffect(() => {
        if(!reloadTenantAdministrators) return;
        const refetchTenantAdministrators = async() =>{
            await fetchTenantAdministrators();
            setReloadTenantAdministrators(false);
        };
        refetchTenantAdministrators();
    },[reloadTenantAdministrators]);
    return(
        <div className="system-administrator-tenant-administrators-page">
            <NavigationBar/>
            <div className="system-administrator-tenant-administrators-page-layout">
                <div>
                    <SystemAdministratorSideBar/>
                </div>
                <div className="system-administrator-tenant-administrators-parent-container">
                    {!Array.isArray(tenantAdministrators) && !showCreateNewTenantAdministratorWindow && !selectedToDeleteTenantAdministrator?
                        (
                            <div className="system-administrator-tenant-administrators-container">
                                <div className="system-administrator-tenant-administrators-header-container">
                                    <h2>Tenant administrators</h2>
                                </div>
                                <div className="system-administrator-loading-tenant-administrators-parent-container">
                                    <div className="system-administrator-loading-tenant-administrators-container">
                                        <div></div>
                                        <p>Loading Tenant Administrators. Please wait...</p>
                                    </div>
                                </div>
                            </div>
                        ):reloadTenantAdministrators && !showCreateNewTenantAdministratorWindow && !selectedToDeleteTenantAdministrator?
                        (
                            <div className="system-administrator-tenant-administrators-container">
                                <div className="system-administrator-tenant-administrators-header-container">
                                    <h2>Tenant administrators</h2>
                                </div>
                                <div className="system-administrator-loading-tenant-administrators-parent-container">
                                    <div className="system-administrator-loading-tenant-administrators-container">
                                        <div></div>
                                        <p>Reloading Tenant Administrators. Please wait...</p>
                                    </div>
                                </div>
                            </div>
                        ):Array.isArray(tenantAdministrators) && tenantAdministrators.length === 0 && !selectedToDeleteTenantAdministrator?
                        (
                            <div className="system-administrator-tenant-administrators-unavailable-container"
                                style={{display:showCreateNewTenantAdministratorWindow? 'none':'block'}}>
                                <h2>No tenant administrators available</h2>
                                <p>There are currently no tenant administrators to display</p>
                                <div>
                                    <button onClick={() => setShowCreateNewTenantAdministratorWindow(true)}>Create Tenant Admin</button>
                                </div>
                            </div>
                        ):Array.isArray(tenantAdministrators) && tenantAdministrators.length > 0?
                        (
                            <div className="system-administrator-tenant-administrators-container">
                                <div className="system-administrator-tenant-administrators-header-container">
                                    <h2>Tenant administrators</h2>
                                    <div className="system-administrator-tenant-administrators-header-controls">
                                        <button title="Add a tenant administrator"
                                            onClick={() => setShowCreateNewTenantAdministratorWindow(true)}>
                                            <img src={`${process.env.PUBLIC_URL}/images/add-icon.png`} alt="Add"/>
                                        </button>
                                    </div>
                                </div>
                                <TenantAdministratorsTable/>
                            </div>
                        ):
                        (<></>)
                    }
                </div>
            </div>
            <NewTenantAdministrator/>
            <EditTenantAdministrator/>
            <DeleteTenantAdministrator/>
        </div>
    );
};
export default TenantAdministrators;